import MapInfoModal from './map-info-modal.vue'
export default MapInfoModal
